// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1XBaK","label":"Section_label__3oWbv","contentWrap":"Section_contentWrap__3SKc4","footer":"Section_footer__Jmu0V","footerInner":"Section_footerInner__1CvCj"};